import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { InvoicePerformaRoutingModule } from "./invoice-performa-routing.module";
import { InvoicePerformaComponent } from "./invoice-performa.component";

// Add missing module imports
import { MatIconModule } from "@angular/material/icon"; // For mat-icon
import { ModalModule } from "ngx-bootstrap/modal"; // For bs-modal
import { ChartsModule, ThemeService } from "ng2-charts"; // Import ChartsModule and ThemeService
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { AddProformaInvoiceComponent } from './add-proforma-invoice/add-proforma-invoice.component';
import { ProformaInvoiceDetailsComponent } from './proforma-invoice-details/proforma-invoice-details.component';
import { ProformaInvoiceReceiptComponent } from './proforma-invoice-receipt/proforma-invoice-receipt.component';
import { PdfCompanyPreviewProformaInvoiceComponent } from './pdf-company-preview-proforma-invoice/pdf-company-preview-proforma-invoice.component';
import { ProformaInvoiceComponent } from './proforma-invoice/proforma-invoice.component';
import { ReceiptComponent } from './receipt/receipt.component';
import { ShareProformaInvoiceComponent } from './share-proforma-invoice/share-proforma-invoice.component';

@NgModule({
  declarations: [InvoicePerformaComponent, AddProformaInvoiceComponent, ProformaInvoiceDetailsComponent, ProformaInvoiceReceiptComponent, PdfCompanyPreviewProformaInvoiceComponent, ProformaInvoiceComponent, ReceiptComponent, ShareProformaInvoiceComponent],
  imports: [
    CommonModule,
    InvoicePerformaRoutingModule,
    MatIconModule,
    ModalModule.forRoot(),
    ChartsModule,
    FormsModule, // Ensure ChartsModule is imported
    ReactiveFormsModule,
    MatDatepickerModule, // Required for datepicker
    MatNativeDateModule, // Required for datepicker functionality
    MatFormFieldModule, // Required for input fields
    MatInputModule,
    MatCheckboxModule, // Required for checkbox
  ],
  exports: [],
  providers: [ThemeService], // Add ThemeService to providers
  entryComponents: [],
})
export class InvoicePerformaModule {}
